import { SVGFC } from '@repo/toolkit/types'

const HouseOneIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12377_381960)">
        <path
          d="M3.02543 11.9594C3.05265 12.0278 3.09977 12.0864 3.16068 12.1276C3.22159 12.1689 3.29349 12.1909 3.36706 12.1909H4.4691V20.2651C4.4691 20.4672 4.63441 20.6325 4.83645 20.6325H18.5826C18.7846 20.6325 18.9499 20.4672 18.9499 20.2651V12.1909H19.8977C19.9712 12.1909 20.0431 12.1689 20.1041 12.1276C20.165 12.0864 20.2121 12.0278 20.2393 11.9594C20.2944 11.8198 20.2613 11.6619 20.1511 11.559L17.8846 9.388V3.73453C17.8846 3.53249 17.7193 3.36719 17.5173 3.36719H15.4932C15.2911 3.36719 15.1258 3.53249 15.1258 3.73453V6.74678L11.9593 3.71249C11.8197 3.57658 11.5956 3.57658 11.4524 3.70882L3.11359 11.5554C3.00706 11.6582 2.97032 11.8198 3.02543 11.9594ZM15.8605 4.10188H17.1499V8.6827L15.8605 7.44841V4.10188ZM11.7022 4.48392L18.983 11.4562H18.5789C18.3769 11.4562 18.2115 11.6215 18.2115 11.8235V19.8978H5.20379V11.8235C5.20379 11.6215 5.03849 11.4562 4.83645 11.4562H4.29277L11.7022 4.48392Z"
          fill={color}
        />
        <path
          d="M12.9848 13.9231C13.6396 13.5483 14.087 12.8505 14.087 12.0435C14.087 10.8449 13.1117 9.86963 11.913 9.86963C10.7143 9.86963 9.73912 10.8449 9.73912 12.0435C9.73912 12.8505 10.1865 13.5483 10.8413 13.9231C9.20348 14.3531 8 15.7379 8 17.3792V17.9131C8 18.0331 8.0974 18.1305 8.2174 18.1305C8.3374 18.1305 8.4348 18.0331 8.4348 17.9131V17.3792C8.43478 15.6362 9.99522 14.2175 11.913 14.2175C13.8309 14.2175 15.3913 15.6362 15.3913 17.3792V17.9131C15.3913 18.0331 15.4887 18.1305 15.6087 18.1305C15.7287 18.1305 15.8261 18.0331 15.8261 17.9131V17.3792C15.8261 15.7379 14.6226 14.3527 12.9848 13.9231ZM10.1739 12.0435C10.1739 11.0844 10.9539 10.3044 11.913 10.3044C12.8722 10.3044 13.6522 11.0844 13.6522 12.0435C13.6522 13.0027 12.8722 13.7827 11.913 13.7827C10.9539 13.7827 10.1739 13.0027 10.1739 12.0435Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12377_381960">
          <rect width="18" height="17.2653" fill={color} transform="translate(3 3.36719)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HouseOneIcon
